import React, { createContext, FC } from 'react';

import { analytics } from '../Firebase';

import AnalyticsAdapter from './AnalyticsAdapter';

export const AnalyticsContext = createContext<typeof AnalyticsAdapter | null>(null);

interface IAnalyticsProvider {
  children: React.ReactNode;
}

const AnalyticsProvider: FC<IAnalyticsProvider> = ({ children }) => {
  const analyticsService = AnalyticsAdapter;

  if (analyticsService) {
    analyticsService.init(analytics);
  }

  return (
    <AnalyticsContext.Provider value={analyticsService}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export default AnalyticsProvider;
